import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MyAccountService } from '../../../services/my-account.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ChangePasswordModel } from '../../../models/change-password-model';
import { PasswordValidator } from '../../../validators/password-validator';
import {ToastService} from 'angular-toastify';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  passwordForm: FormGroup;

  constructor(
    private myAccountService: MyAccountService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private _toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.passwordForm = this.formBuilder.group({
      currentPassword: [''],
      password: [''],
      confirmPassword: [''],
    }, {
      validator:  [PasswordValidator.MatchPassword, PasswordValidator.WeakPassword] // your validation method
    });

  }

  submit() {
    const model = new ChangePasswordModel();
    model.currentPassword = this.passwordForm.value.currentPassword;
    model.newPassword = this.passwordForm.value.password;

    this.myAccountService.changePassword(model).subscribe(() => {
      this._toastService.success(
        'Password has been changed successfully'
      );
      this.returnBack();
    });
  }

  returnBack() {
    this.router.navigate(['..'], { relativeTo: this.route });
  }
}
